<template>
  <SiruiSearch
    ref="baseInfoFormRef"
    :query="baseFormData"
    :columns="formColumn"
    :isQueryPanel="false"
    :rules="formRules"
    @changeMethod="changeMethod"
    :isDisabledForm="isDisabledForm"
  >
  </SiruiSearch>
</template>

<script>
  import { baseFormColumn, baseFormRules } from './index.js';
  import goodsApi from '@/api/masterData/goods.js';
  export default {
    name: 'BaseInfoForm',
    props: {
      contractStatus: {
        type: String,
        default: '',
      },
      // 网络获取数据反填
      fetchData: {
        type: Object,
        default: () => {},
      },
      totalAmount: {
        type: Number,
        default: () => 0,
      },
    },
    data() {
      return {
        baseFormData: {
          contractNo: '',
          contractStatus: '',
          parkCompanyName: '',
          parkDepartmentName: '',
          parkDepartmentCode: '',
          operatorName: '',
          operaterNo: '',
          contractType: '',
          signDate: '',
          signPerson: '',
          contractNature: '',
          contractValidFrom: '',
          contractValidUntil: '',
          storageCompanyNo: '',
          storageCompanyName: '',
          storageName: '',
          storageNo: '',
          goodsType: '',
          goodsTypeName: '',
          goodsCategory: '',
          goodsCategoryName: '',
          pledgeeNo: '',
          pledgeeName: '',
          pledgeeContactPerson: '',
          pledgeeContactWay: '',
          pledgorName: '',
          pledgorNo: '',
          pledgorContactPerson: '',
          pledgorContactWay: '',
          relatedContactPerson: '',
          relatedContactWay: '',
          receiveMoneyMethod: undefined,
          contractAmount: '',
          absentInterestRate: '',
          depositBank: '',
          bankAccount: '',
          contractQuantity: '',
          remark: '',
          relatedLeaseContractNo: '',
          relatedName: '',
          relatedNo: '',
          projectName: '',
          projectNo: '',
          settlementEntityName: '',
          settlementEntityNo: '',
          paperContractNo: '',
        },
        isDisabledForm: false,
        contractNatureList: [], // 合同性质
        contractPayMethodList: [], //收款方式
        contractTypeList: [], // 合同类型
        contractStatusList: [], // 合同状态
        isRenewStatus: false, //是否续签状态
        isDisabledSettlementEntityName: true, // 是否禁用结算主体
        goodsTypeList: [], // 货物品类
        goodsCategoryList: [], // 获取类型
        settlementEntityNameList: [], //结算主体
        settlementEntityNameMap: {},
        settlementEntityCodeList: [],
        isDisableProjectName: false,
        isProjectToContract: false, //是否为项目转合同
      };
    },
    computed: {
      formColumn() {
        return baseFormColumn(this);
      },
      formRules() {
        return baseFormRules(this);
      },
    },
    mounted() {
      this.contractNatureList = this.dictListMap.SuperviseContractNature;
      this.contractPayMethodList = this.dictListMap.SuperviseContractPayMethod;
      this.contractTypeList = this.dictListMap.SuperviseContractType;
      this.contractStatusList = this.dictListMap.SuperviseContractStatusType;
      if (this.$route.query?.projectCode) {
        this.isProjectToContract = true;
      }
      this.getGoodsParentApi(); // 获取商品大类
    },
    methods: {
      // 获取商品大类数据
      async getGoodsParentApi() {
        const { data } = await this.$axios.post(goodsApi.PRODUCT_TYPE, {
          parentProductStatus: 'ZT03',
          selectCompanyCode: this.userInfo.companyCode,
          adminFlag: this.userInfo.adminFlag,
        });
        if (data.code == 0) {
          this.goodsTypeList = data.data?.map((item) => {
            return {
              value: item.parentProductNo,
              label: item.productChName,
            };
          });
        } else {
          console.error('获取商品大类数据失败');
        }
      },
      // 根据货物类型查询货物品类
      async getGoodsCategoryApi(goodType) {
        let productParentCodes = [];
        if (goodType) {
          productParentCodes = goodType;
        } else {
          productParentCodes = this.goodsTypeList
            .filter((item) => this.baseFormData.goodsType.includes(item.value))
            .map((item) => item.value);
        }

        const { data } = await this.$axios.post(goodsApi.GOODS_LIST_BY_TYPE, {
          parentProductStatus: 'ZT03',
          productParentCodes,
          selectCompanyCode: this.userInfo.companyCode,
          adminFlag: this.userInfo.adminFlag,
        });
        if (data.code == 0) {
          this.goodsCategoryList = data.data?.map((item) => {
            return {
              value: item.productDetailCode,
              label: item.productChName,
            };
          });
          // 过滤掉不在goodsCategoryList 中的goodsCategory
          // goodsType为空，清空goodsCategory
          this.baseFormData.goodsCategory = this.goodsCategoryList
            .filter((item) => this.baseFormData.goodsCategory.includes(item.value))
            .map((item) => item.value);
          if (this.baseFormData.goodsType.length == 0) {
            this.baseFormData.goodsCategory = [];
          }
        } else {
          console.error('获取货物类型数据失败');
        }
      },
      // uniqueThirdParty(selectRowData, name) {
      //   if (this.thirdPartyCodeList.includes(selectRowData.partnerCode)) {
      //     this.$message.error('出质方，质权方，关联方不能为同一个合作伙伴');
      //     return;
      //   } else {
      //     this.settlementEntityNameList
      //       .filter((item) => item.value != this.baseFormData.pledgeeNo)
      //       .concat({
      //         label: selectRowData.partnerZhName,
      //         value: selectRowData.partnerCode,
      //       });
      //     this.baseFormData.pledgeeNo = selectRowData.partnerCode;
      //     this.baseFormData.pledgeeName = selectRowData.partnerZhName;
      //   }
      // },
      changeMethod({ val, prop }) {
        console.log(val, prop);
        const selectRowData = val[0];
        if (prop == 'storageCompanyNo') {
          this.baseFormData.storageCompanyNo = selectRowData.storageCompanyCode;
          this.baseFormData.storageCompanyName = selectRowData.companyName;
        } else if (prop == 'storageName') {
          this.baseFormData.storageName = selectRowData.storageName;
          this.baseFormData.storageNo = selectRowData.storageCode;
          this.baseFormData.storageCompanyNo = selectRowData.storageCompanyCode;
          this.baseFormData.storageCompanyName = selectRowData.companyName;
          console.log(selectRowData, '111');
        } else if (prop == 'contractNature') {
          this.settlementEntityNameList = [];
          this.baseFormData = {
            ...this.baseFormData,
            pledgeeNo: '',
            pledgeeName: '',
            pledgorNo: '',
            pledgorName: '',
            relatedNo: '',
            relatedName: '',
            settlementEntityName: '',
            settlementEntityNo: '',
          };
          this.$refs.baseInfoFormRef.$refs.relatedName &&
            this.$refs.baseInfoFormRef.$refs.relatedName[0]?.resetClick();
          this.$refs.baseInfoFormRef.$refs.pledgorName &&
            this.$refs.baseInfoFormRef.$refs.pledgorName[0]?.resetClick();
          this.$refs.baseInfoFormRef.$refs.pledgeeName &&
            this.$refs.baseInfoFormRef.$refs.pledgeeName[0].resetClick();
        } else if (prop == 'settlementEntityName') {
          this.baseFormData.settlementEntityName = this.settlementEntityNameList.find(
            (item) => item.value == val
          )?.label;
          this.baseFormData.settlementEntityNo = val;
        } else if (prop == 'goodsType') {
          this.getGoodsCategoryApi();
        } else if (prop == 'pledgeeName') {
          // 质权方名称
          if (this.settlementEntityCodeList.includes(selectRowData.partnerCode)) {
            this.$message.error('出质方，质权方，关联方不能为同一个合作伙伴');
            this.baseFormData = {
              ...this.baseFormData,
              pledgeeNo: '',
              pledgeeName: '',
            };
            console.log(this.$refs.baseInfoFormRef.$refs.pledgeeName, '1111');
            this.$refs.baseInfoFormRef.$refs.pledgeeName[0].resetClick();
            return;
          } else {
            this.settlementEntityNameMap = {
              ...this.settlementEntityNameMap,
              pledgeeName: {
                label: selectRowData.partnerZhName,
                value: selectRowData.partnerCode,
              },
            };
            this.baseFormData.pledgeeNo = selectRowData.partnerCode;
            this.baseFormData.pledgeeName = selectRowData.partnerZhName;
            this.baseFormData.settlementEntityName = '';
            this.baseFormData.settlementEntityNo = '';
            this.changeEntityHandle();
          }
        } else if (prop == 'pledgorName') {
          // 出质方名称
          if (this.settlementEntityCodeList.includes(selectRowData.partnerCode)) {
            this.$message.error('出质方，质权方，关联方不能为同一个合作伙伴');
            this.baseFormData = {
              ...this.baseFormData,
              pledgorNo: '',
              pledgorName: '',
            };
            console.log(this.$refs.baseInfoFormRef.$refs.pledgorName, '1111');
            this.$refs.baseInfoFormRef.$refs.pledgorName[0].resetClick();
          } else {
            this.settlementEntityNameMap = {
              ...this.settlementEntityNameMap,
              pledgorName: {
                label: selectRowData.partnerZhName,
                value: selectRowData.partnerCode,
              },
            };
            this.baseFormData.pledgorNo = selectRowData.partnerCode;
            this.baseFormData.pledgorName = selectRowData.partnerZhName;
            this.baseFormData.settlementEntityName = '';
            this.baseFormData.settlementEntityNo = '';
            this.changeEntityHandle();
          }
        } else if (prop == 'relatedName') {
          // 关联方名称
          if (this.settlementEntityCodeList.includes(selectRowData.partnerCode)) {
            this.$message.error('出质方，质权方，关联方不能为同一个合作伙伴');
            this.baseFormData = {
              ...this.baseFormData,
              relatedNo: '',
              relatedName: '',
            };
            this.$refs.baseInfoFormRef.$refs.relatedName[0].resetClick();
            return;
          } else {
            this.settlementEntityNameMap = {
              ...this.settlementEntityNameMap,
              relatedName: {
                label: selectRowData.partnerZhName,
                value: selectRowData.partnerCode,
              },
            };
            this.baseFormData.relatedNo = selectRowData.partnerCode;
            this.baseFormData.relatedName = selectRowData.partnerZhName;
            this.baseFormData.settlementEntityName = '';
            this.baseFormData.settlementEntityNo = '';
            this.changeEntityHandle();
          }
        } else if (prop == 'depositBank') {
          this.baseFormData.depositBank = selectRowData.bankName;
          this.baseFormData.bankAccount = selectRowData.unionKey;
        } else if (prop == 'projectName') {
          this.baseFormData.projectName = selectRowData.projectName;
          this.baseFormData.projectNo = selectRowData.projectCode;
        } else if (prop == 'relatedLeaseContractNo') {
          this.baseFormData.relatedLeaseContractNo = selectRowData.contractNo;
          // this.baseFormData.relatedName = selectRowData.contractName;
          this.baseFormData.relatedNo = selectRowData.contractNo;
        } else if (prop == 'contractValidFrom' || prop == 'contractValidUntil') {
          this.$emit('contractValidFrom', {
            contractValidFrom: this.baseFormData.contractValidFrom,
            contractValidUntil: this.baseFormData.contractValidUntil,
          });
        }
      },
      changeEntityHandle() {
        this.$emit('updateSettlementEntityList', {
          pledgorNo: this.baseFormData.pledgorNo,
          pledgorName: this.baseFormData.pledgorName,
          pledgeeNo: this.baseFormData.pledgeeNo,
          pledgeeName: this.baseFormData.pledgeeName,
          relatedNo: this.baseFormData.relatedNo,
          relatedName: this.baseFormData.relatedName,
        });
      },
      async getValidateFormData() {
        const formData = await this.$refs.baseInfoFormRef.getValidateFormData();
        const currentStatus = this.$route.query.status;
        return {
          ...formData,
          // 几个额外字段
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          adminFlag: this.userInfo.adminFlag,
          goodsType: formData.goodsType.join(','),
          goodsTypeName: this.goodsTypeList
            .filter((item) => formData.goodsType.includes(item.value))
            .map((item) => item.label)
            .join(','),
          goodsCategory: formData.goodsCategory.join(','),
          goodsCategoryName: this.goodsCategoryList
            .filter((item) => formData.goodsCategory.includes(item.value))
            .map((item) => item.label)
            .join(','),
          // 特殊处理id
          id:
            ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01'
              ? ''
              : formData?.id,
        };
      },
      initData() {
        console.log('初始化数据');
        this.baseFormData = {
          operatorName: this.userInfo.userName,
          operaterNo: this.userInfo.userCode,
          parkDepartmentName: this.userInfo.departmentName,
          parkDepartmentNo: this.userInfo.departmentCode,
          parkCompanyName: this.userInfo.companyName,
          parkCompanyNo: this.userInfo.companyCode,
          contractType: '01',
        };
        // 从立项那边跳转过来
        const { projectCode, projectName, status } = this.$route.query;
        if (status == 'create' && projectCode && projectName) {
          this.baseFormData = {
            ...this.baseFormData,
            projectNo: projectCode,
            projectName: projectName,
          };
          this.isDisableProjectName = true;
        }
      },
    },
    watch: {
      // 监听合同金额变化
      totalAmount: {
        handler(val) {
          console.log('接收参数', val);
          this.baseFormData = {
            ...this.baseFormData,
            contractAmount: val + '',
          };
        },
        immediate: true,
      },
      contractStatus: {
        handler(val) {
          if (['02', '03', '05', '06'].includes(val)) {
            // 如果当前是续签的时候只有主体不可以编辑就是
            const currentStatus = this.$route.query.status;
            if (['renew', 'change'].includes(currentStatus)) {
              this.isRenewStatus = true;
            } else if (['create'].includes(currentStatus)) {
              this.isDisabledForm = false;
            } else {
              this.isDisabledForm = true;
            }
          } else if (['-1'].includes(val)) {
            this.isDisabledForm = true;
          } else {
            this.isDisabledForm = false;
          }
        },
        immediate: true,
      },
      settlementEntityNameMap: {
        handler(val) {
          console.log(val, '==监听=>>');
          if (Object.keys(val).length) {
            this.settlementEntityNameList = [];
            this.settlementEntityCodeList = [];
            for (const key in val) {
              this.settlementEntityNameList.push(val[key]);
              this.settlementEntityCodeList.push(val[key].value);
            }
          }
        },
        deep: true,
        immediate: true,
      },
      // 监听表单数据变动来禁用结算主体
      baseFormData: {
        handler(val) {
          console.log(val, '表单数据');
          const { pledgeeNo, pledgorNo, relatedNo } = val;
          if (pledgeeNo || pledgorNo || relatedNo) {
            this.isDisabledSettlementEntityName = false;
          } else {
            this.isDisabledSettlementEntityName = true;
          }
        },
        immediate: true,
        deep: true,
      },
      fetchData: {
        handler(val) {
          if (val && Object.keys(val).length) {
            let newObj = {};
            const currentStatus = this.$route.query.status;
            for (const key in val) {
              if (typeof val[key] == 'number') {
                newObj[key] = val[key] + '';
              } else {
                newObj[key] = val[key];
              }
              // 特殊处理字段
              if (
                ['goodsType', 'goodsTypeName', 'goodsCategory', 'goodsCategoryName'].includes(key)
              ) {
                newObj[key] = val[key].split(',');
              }
              // this.getGoodsCategoryApi(); 此处会重复请求
            }
            this.getGoodsCategoryApi(newObj['goodsType']);
            const { pledgeeNo, pledgeeName, pledgorNo, pledgorName, relatedNo, relatedName } = val;
            if (pledgeeNo && pledgeeName) {
              this.settlementEntityNameList.push({
                value: pledgeeNo,
                label: pledgeeName,
              });
              this.settlementEntityNameMap['pledgeeName'] = {
                label: pledgeeName,
                value: pledgeeNo,
              };
            }
            if (pledgorNo && pledgorName) {
              this.settlementEntityNameList.push({
                value: pledgorNo,
                label: pledgorName,
              });
              this.settlementEntityNameMap['pledgorName'] = {
                label: pledgorName,
                value: pledgorNo,
              };
            }
            if (relatedNo && relatedName) {
              this.settlementEntityNameList.push({
                value: relatedNo,
                label: relatedName,
              });
              this.settlementEntityNameMap['relatedName'] = {
                label: relatedName,
                value: relatedNo,
              };
            }
            const isCopyStatus =
              ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01';
            this.baseFormData = {
              ...newObj,
              // 单独处理下复制时候合同号和状态
              contractNo: isCopyStatus ? null : newObj?.contractNo,
              contractStatus: isCopyStatus ? null : newObj?.contractStatus,
              gmtCreate: isCopyStatus ? null : newObj?.gmtCreate,
              gmtModified: isCopyStatus ? null : newObj?.gmtModified,
              settlementEntityName: isCopyStatus ? '' : newObj?.settlementEntityName,
              settlementEntityNo: isCopyStatus ? '' : newObj?.settlementEntityNo,
            };
          } else {
            this.initData();
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style></style>
